import { paths } from '../../common/constants/pathVariables.js';
import { devicesMsg, t, voiceAndBroadbandMsg } from '../../common/i18n/index.js';
import { useAuth } from '../../public/site/AuthProvider.js';
import { HeroHeading, HeroHeadingType } from '../HeroHeading/index.js';
import { LocalNavi } from '../LocalNavi/index.js';
import type { BreadCrumbList } from '../BreadCrumbs/index.js';
import type { LocalNaviItem } from '../LocalNavi/index.js';
import type { ReactNode } from 'react';

interface EmployeeSubscriptionsProps {
  breadCrumbs: BreadCrumbList;
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export const getDisplayCategories = (showExpiringEppSubscriptionHint: boolean) => {
  return [
    {
      children: t.JPRH(voiceAndBroadbandMsg),
      to: paths.EMPLOYEE_SUBSCRIPTIONS,
    },
    {
      children: t.JJTM(devicesMsg),
      to: paths.EMPLOYEE_DEVICES,
      hint: showExpiringEppSubscriptionHint,
    },
  ].filter(Boolean) as LocalNaviItem[];
};

export const EoeSubscriptionsLayout = ({ breadCrumbs, title, subtitle, children }: EmployeeSubscriptionsProps) => {
  const { authenticatedUser } = useAuth();

  const displayCategories = getDisplayCategories(!!authenticatedUser?.expiringEppSubscriptions?.length);

  return (
    <div className="of-subscriptions-scene">
      <HeroHeading
        breadCrumbPaths={breadCrumbs}
        heroHeadingType={HeroHeadingType.BLANK}
        title={title}
        subtitle={subtitle}
        center={true}
        smallSubtitle={true}
      />
      <LocalNavi wide categories={displayCategories} />
      {children}
    </div>
  );
};
